export default {
  headerMenuSocial: 'Social Responsibility',
  languageSwitchAria: 'Switch language',
  headerLangZh: '中文',
  headerLangEn: 'English'
}



// WEBPACK FOOTER //
// ./src/i18n/locales/en/common.js